import React from 'react';
import PropTypes from 'prop-types';

const CNAME = 'HeroImage';

const HeroImageSourcesWebp = ({ treatments, title }) => {
  let imgSrc = null;
  const sources = treatments.map(({ href, webphref, media, defaultImg, key }) => {
    imgSrc = imgSrc || (defaultImg && href);
    return (
      <React.Fragment key={key} >
        <source {...{ srcSet: webphref, media, key: `${key}-webp`, type: 'image/webp' }}/>
        <source {...{ srcSet: href, media, key: `${key}-jpg`, type: 'image/jpeg' }}/>
      </React.Fragment>
    );
  });

  sources.push(<img key="img" className={`${CNAME}__img`} src={imgSrc} alt={title} />);
  return sources;
};

HeroImageSourcesWebp.propTypes = {
  treatments: PropTypes.arrayOf(PropTypes.shape({
    defaultImg: PropTypes.bool.isRequired,
    href: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
    media: PropTypes.string.isRequired
  })).isRequired,
  title: PropTypes.string
};


export default HeroImageSourcesWebp;
